import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.misc.paises.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El País ha sido creado con éxito."}
                title={"Nuevo País"}
                buttonTitle={"Nuevo País"}
                buttonIcon={"fa fa-plus fa-lg"}
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <div className="ui-field">
                        <label>Nombre</label>
                        <input type="text" name="nombre" className="form-control" autoFocus data-auto-focus="true" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/misc/Pais/Create.js